<div class="py-2 pt-0">
  <h3 class="font-thin border-b border-gray-300 mb-2 p-1">{{title}}</h3>
</div>

<app-operations-progress-chart-1 [index]="1"
                                 [store]="store"
                                 (initialized)="subReportElementInitialized($event)"></app-operations-progress-chart-1>
